<div
    class="quickbet-panel partial-overlay quickbet-btm-0"
    id="quickbet-panel"
    data-crlat="quickbetPanel"
    [ngClass]="{ 'quickbet-slide-up': slideUpAnimation, 'quickbet-slide-down': slideDownAnimation, 'quickbet-srm': isSRMBet }"
    [class.nw-indicator-shown]="NWIndicatorShown"
    [class.nw-indicator-shown-native-ios]="nativeIos">
    @if (selection && selection.error) {
        <!-- Quickbet MS unavailable panel -->
        @if (!selection.error.selectionUndisplayed) {
            <request-error [loadFailed]="selection.error" (reloadFn)="reuseSelection()"> </request-error>
        }
        @if (selection.error.selectionUndisplayed) {
            <div
                class="selection-undisplayed-error"
                [i18n]="'quickbet.betPlacementErrors.' + selection.error.selectionUndisplayed"
                data-crlat="selectionUndisplayed"></div>
        }
    } @else {
        <!-- Quick Bet Information Panel -->
        @if (selection.disabled) {
            @if (selection.marketStatusCode === 'S') {
                <div class="market-suspended-section" [i18n]="'quickbet.srmMarketSuspendedMessage'"></div>
            } @else if (selection.outcomeStatusCode === 'S') {
                <div class="market-suspended-section" [i18n]="'quickbet.betPlacementErrors.OUTCOME_SUSPENDED'"></div>
            } @else {
                <div class="market-suspended-section" [i18n]="'quickbet.betPlacementErrors.EVENT_SUSPENDED'"></div>
            }
        }

        @if (serviceClosureService.userServiceClosureOrPlayBreak) {
            <div class="closure-message-container" [textContent]="serviceClosureService.userAccountInfo || 'undefined'"></div>
        }

        <srm-quickbet-partial-overlay-selection
            [selection]="selection"
            [isQuickBet]="isQuickBet"
            [isQbPartialOverlay]="true"
            (openFullOverlayFn)="openFullOverlayFnHandler()"
            (removeSelectionFn)="removeSelectionFnHandler()"
            [placeBetPending]="placeBetPending"
            [isSRMBet]="isSRMBet"
            [selectedQuestionAndAnswers]="selectedQuestionAndAnswers"
            [srmOdds]="srmOdds"
            data-crlat="quickbet.selection">
        </srm-quickbet-partial-overlay-selection>

        @if (selection.disabled) {
            <button (click)="ok()" class="srm-ok-btn">
                <span [i18n]="'quickbet.buttons.ok'"></span>
            </button>
        }
    }
</div>
